<section class="ftco-section ftco-no-pt ftco-no-pb ftco-services-2 bg-light" style="margin: 5% 0;">
    <div class="container">

        <div class="row d-flex" style="border:3px solid black">

            <div class="col-lg-12">
                <!-- <h2>Free <span style="color: #004aad;">COVID-19 Consultation For Indian Patients Only</span></h2> -->
                <div class="col-sm-12 heading-section text-center">
                    <h2> <span style="color: #004aad;font-weight:bold">Free Counseling</span></h2>
                </div>
                <p class="center-text-p font-weight-bold text-center">
                    eGlobalDoctors is working in association with TANA and AAPI volunteers
                    to make this counseling service possible for a variety of specialties.
                </p>

                <p class="center-text-p font-weight-bold text-center">
                    This service is not for emergencies.
                    Advise will be given by our doctors on a good faith, best effort basis.
                    Please consult your physician for full medical consultation.
                </p>
            </div>
            <div class="col-sm-12 col-lg-1"></div>
            <div class="col-sm-12 col-lg-3 text-muted lead text-center m-auto">
                <hr class="equip-tech-hr text-weight-bold">
                In Partnership With
            </div>
            <div class="col-sm-12 col-lg-3 mt-2 mb-5 centerImg">
                <img src="assets/images/special/aapi.png" style="width:215px;height: 115px;margin: auto;"
                    alt="Free-Covid-Consultation-For-Indian-Patients">
            </div>
            <div class="col-sm-12 col-lg-3 mt-2 mb-5 centerImg">
                <img src="assets/images/special/tana1.png" style="width:110px;margin: auto;"
                    alt="American Association of Physicians of Indian Origin">
            </div>
            <!-- <div class="col-sm-12 col-lg-4 mt-2 mb-5 centerImg">
                                <img src="assets/images/special/sewa.png" style="width:115px;height: 105px;margin: auto;"
                                    alt="Sewa International">
                            </div> -->
            <div class="col-sm-12 col-lg-2"></div>
            <div class="col-sm-12 col-lg-6 mt-2 mb-5">
                <h3 style="font-weight: 800; text-align: center;">How does it work?</h3>
                <h4 style="font-weight: 800; text-align: center;">Need Help?<a href="https://youtu.be/SDBvTSp7R9M"
                        style="color:#004aad" target="_blank">(Watch Video)</a><img class="pl-1"
                        src="assets/images/playicon.png"></h4>
                <p class="center-text-p font-weight-bolder"><span
                        style="text-decoration: underline;font-weight: bolder;">Step 1:</span> Fill up the counseling
                    registration form
                    (<button class="ui-button-info ui-button-rounded" pButton label="Click here"
                        (click)="open_form()"></button>)

                </p>


                <p class="center-text-p text-center">If you have problems in filling the form, please send your name,
                    age and phone
                    to <a style="color:#004aad" href="mailto:support@eglobaldoctors.com">support@eglobaldoctors.com</a>.
                    One of the volunteers would call and assist you to fill the form and help with telemedicine
                    counseling.
                </p>
                <p class="center-text-p font-weight-bolder"><span
                        style="text-decoration: underline;font-weight: bolder;">Step 2:</span>Add Members(<button
                        class="ui-button-info ui-button-rounded" pButton label="Click here"
                        (click)="open_membership()"></button>) to avail all the features
                </p>
                <p class="center-text-p text-center">
                    Get free membership for lifetime.
                </p>
                <p class="center-text-p font-weight-bolder"><span
                        style="text-decoration: underline;font-weight: bolder;">Step 3:</span> Click
                    on the Zoom link to join the meeting.
                </p>
                <p class="center-text-p text-center">Doctor
                    will be assigned
                    directly if you complete Step 1. If you don’t complete Step 1, then our volunteer will help you to
                    fill out the form once you join Zoom Meeting.
                </p>
            </div>

            <div class="col-sm-12 col-lg-6 mt-2 mb-5">

                <h3 style="font-weight: 800; text-align: center;">Meeting Details</h3>
                <div class="row" *ngIf="this.response_success!=null && this.response_success">

                    <div class="col-sm-12 col-lg-10 text-center ml-5" style="margin-top: 3%;border: 1px solid black;">
                        <p class="font-weight-bolder" style="margin-top: 3%;font-size:16px;">Every Sunday</p>
                        <p class="font-weight-bolder" style="font-size:16px;">{{this.weekends[0][0]}} -
                            {{this.weekends[0][1]}}</p>
                        <p class="font-weight-bolder" style="font-size:16px;">{{this.weekends[1][0]}} -
                            {{this.weekends[1][1]}}(USA)</p>
                    </div>
                </div>
                <div class="col-sm-12 col-lg-12" style="margin-top: 10%;">

                    <div class="row ">

                        <button class="button-glow ui-button-info ui-button-rounded" pButton
                            style="display: block ruby;height: 50px;margin:10px;background:#004aad;width:170px;margin-left:60px;"
                            (click)="openZoomLink()">
                            <span style="font-size: 34px;vertical-align: middle;" class="icon-video_call"></span>
                            <span>Join Meeting</span>

                        </button>
                        <button class="button-glow ui-button-info ui-button-rounded text-dark bg-white" pButton
                            style="display: block ruby;height: 50px;margin:10px;width:170px;" (click)="openLink('PORTAL_BASE_URL',feedback_url,'_blank');">
                            <span style="font-size: 34px;vertical-align: middle;" class="icon-video_call"></span>
                            <span style="color:#004aad;">Leave Feedback</span>

                        </button>

                    </div>

                </div>



            </div>

        </div>
    </div>
</section>